<template>
    <el-drawer title="错误提示" :visible.sync="errMsgShow" :append-to-body="true" size="auto">
        <div v-if="data" class="drawer-content">
            <template v-if="data.lockingOrder && data.lockingOrder.length > 0">
                <div class="tips">
                    本次提交数据包含<span class="color-danger">{{ data.lockingOrder.length }}条</span>被结算单锁定的订单。
                </div>
                <dl class="MT20">
                    <dt>结算单锁定订单：</dt>
                    <dd v-for="(item, index) in data.lockingOrder" :key="index">{{ item }}</dd>
                </dl>
            </template>
            <template v-if="data.reconciliationFailedOrder && data.reconciliationFailedOrder.length > 0">
                <div class="tips">
                    本次提交数据包含<span class="color-danger">{{ data.reconciliationFailedOrder.length }}条</span>未收入对账或对账失败的订单。
                </div>
                <dl class="MT20">
                    <dt>未收入对账成功订单：</dt>
                    <dd v-for="(item, index) in data.reconciliationFailedOrder" :key="index">{{ item }}</dd>
                </dl>
            </template>
            <template v-if="data.insufficientBalanceOrder && data.insufficientBalanceOrder.length > 0">
                <div class="tips">
                    有<span class="color-danger">{{ data.insufficientBalanceOrder.length }}条</span>因供应商未结款金额不足，无法退款。
                </div>
                <dl class="MT20">
                    <dt>因供应商未结款金额不足，无法退款：</dt>
                    <dd v-for="(item, index) in data.insufficientBalanceOrder" :key="index">{{ item }}</dd>
                </dl>
            </template>
        </div>
        <div class="drawer-footer">
            <el-button type="primary" @click="errMsgShow = false">知道了</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return {
            errMsgShow: false,
            data: null,
        }
    },
    methods: {
        show(data) {
            this.data = data
            this.errMsgShow = true
        }
    }
}
</script>

<style lang="scss" scoped>
.tips {
    margin-bottom: 5px;
}

dt {
    font-size: 14px;
    font-weight: 700;
}

dd {
    margin-top: 5px;
}
</style>